import useDesignSystemStore, {
  GenerationStatus,
} from "@/store/zustand/aiDesignSystemBuilder";
import React from "react";
import { ReactNode } from "react";

const statusHeader: Partial<Record<GenerationStatus, string>> = {
  [GenerationStatus.ContextSelection]: "Select Context",
  [GenerationStatus.GeneratingContext]: "Generating Overview",
  [GenerationStatus.Editing]: "Edit Plan",
  [GenerationStatus.GeneratingStory]: "Generating Story",
  [GenerationStatus.WaitingForUserAction]: "Review Story",
  [GenerationStatus.Success]: "Created Story",
  [GenerationStatus.Error]: "Error",
};

const statusDescription: Partial<Record<GenerationStatus, ReactNode>> = {
  [GenerationStatus.ContextSelection]: (
    <div>
      Use the file explorer to select files or folders that are relevant.
      <br /> <br /> Then, find some example usages. Select snippets from the
      code editor or select elements in the canvas to use.
    </div>
  ),
  [GenerationStatus.GeneratingContext]: (
    <div>Generating an overview of the story...</div>
  ),
  [GenerationStatus.Editing]: (
    <div>
      Edit the story by modifying context, changing the plan, or updating
      examples.
    </div>
  ),
  [GenerationStatus.GeneratingStory]: <div>Generating the story...</div>,
  [GenerationStatus.WaitingForUserAction]: (
    <div>
      Review the story and make any changes. You can retry the generation or
      apply the changes.
    </div>
  ),
  [GenerationStatus.Success]: <div>View your story in the Assets panel.</div>,
  [GenerationStatus.Error]: (
    <div>An error occured: you can retry the generation.</div>
  ),
};

const GenerationInstructions = () => {
  const status = useDesignSystemStore((state) => state.generation.status);

  return (
    <div className="flex flex-col gap-2">
      <div className="font-bold">{statusHeader[status]}</div>
      <div className="text-2xs text-secondary-900 font-normal">
        {statusDescription[status]}
      </div>
    </div>
  );
};

export default React.memo(GenerationInstructions);
